<template>
<div>
    <b-container>
        <b-row>
            <b-col class="headerpic">
                <img :src="wurl+'/imgsrv/'+this.headerpic">
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <br>
                <b-breadcrumb :items="items"></b-breadcrumb>
            </b-col>
        </b-row>

        <b-row class="content">
            <b-col>
                <b-card class="shadow">
                    <div v-html="content_fr"></div>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
import axios from 'axios'
import {
    globalSiteSetting
} from "../main.ts";
export default {
    data() {
        return {
            wurl: globalSiteSetting.siteurl,
            items: [{
                    text: 'Accueil',
                    to: '/'
                },
                {
                    text: 'About',
                    active: true
                }
            ],
            content_fr: '',
            title_fr: '',

            content_en: '',
            title_en: '',

            headerpic: 'ajaxloader.gif'
        }
    },
    methods: {
        retrievedata() {
            var app = this
            var weburl = this.wurl
            axios.get(weburl + '/api.data.php?req=content&p=clients&lang=fr&auth=razafy', {
                    crossDomain: true
                })
                .then(response => {
                    //console.log('title is:'+ response.data.title)
                    // console.log('content is:'+ response.data.content)
                    //console.log('headerpic is:' + response.data.headerpic)

                    this.title_fr = response.data.title_fr
                    this.content_fr = response.data.content_fr

                    this.title_en = response.data.title_en
                    this.content_en = response.data.content_en

                    this.headerpic = response.data.headerpic

                })
        },
        scrollToTop() {
            // scroll on top every load page        
            window.scrollTo(0, 0);
        }
    },
    mounted() {
        this.retrievedata()
        this.scrollToTop()
    }
}
</script>
